<template>
  <div class="formBox">
    <Collapse v-model="value2" simple style="border: 0">
      <Panel name="5" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="入职申请" />
        <Form
          slot="content"
          :label-width="140"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :model="formItem"
          ref="formItem"
          :rules="rules"
          :disabled="isHistory"
        >
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="7">
              <FormItem label="员工姓名">
                <Input v-model="formItem.userName">
                  <Button
                    type="primary"
                    slot="append"
                    icon="ios-search"
                    @click="openSelectEmp"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="7">
              <FormItem label="应聘职位" prop="candidatePosition">
                <Input v-model="formItem.candidatePosition" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="个人信息" />
        <Form
          :label-width="140"
          slot="content"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :disabled="isHistory"
        >
          <Row>
            <Col :xxl="3" :xl="5" :lg="7" :md="9" :sm="11" :xs="12">
              <FormItem :label-width="0">
                <Button type="primary">个人信息确认</Button>
              </FormItem>
            </Col>
            <Col :xxl="3" :xl="5" :lg="7" :md="9" :sm="11" :xs="12">
              <FormItem :label-width="0">
                <Button type="primary" @click="openJobApplaction"
                  >查看应聘申请表</Button
                >
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="中文姓名：">
                <Input disabled v-model="formItem.userName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="性别：">
                <Select
                  disabled
                  v-model="formItem.gender"
                  :clearable="true"
                  placeholder=""
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in genderList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="民族：">
                <Select
                  v-model="formItem.ethnic"
                  :clearable="true"
                  placeholder=""
                  disabled
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in nationList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="证件号码：">
                <Input disabled v-model="formItem.nationalIdNumber" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="国籍：">
                <Select
                  v-model="formItem.nationality"
                  :clearable="true"
                  placeholder=""
                  disabled
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in nationalityList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="护照号码：">
                <Input disabled v-model="formItem.passportnumber" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="姓（拼音）：">
                <Input disabled v-model="formItem.lastNamePinyin" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="名（拼音）：">
                <Input disabled v-model="formItem.firstNamePinyin" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="英文名：">
                <Input disabled v-model="formItem.userEname" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="年龄：">
                <Input disabled v-model="formItem.age" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="手机：">
                <Input disabled v-model="formItem.mobilePersonal" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="个人电子邮箱：">
                <Input disabled v-model="formItem.mail" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="婚姻状况：">
                <Input disabled v-model="formItem.maritalStatus" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="常住地址：">
                <Input disabled v-model="formItem.homeAddress" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="户籍地址：">
                <Input disabled v-model="formItem.legalAddress" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="入职信息" />
        <Form
          :label-width="140"
          slot="content"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :model="formItem"
          ref="formItem"
          :rules="rules"
          :disabled="isHistory"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="雇佣日：" prop="latestHiringDate">
                <Date-picker
                  v-model="formItem.latestHiringDate"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="有效雇佣日：">
                <Date-picker
                  v-model="formItem.serviceStartDate"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                >
                </Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="社会工龄起始日：">
                <Date-picker
                  type="date"
                  placeholder=""
                  v-model="formItem.socialWorkStartDate"
                  style="width: 100%"
                >
                </Date-picker>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="试用期结束日：">
                <Date-picker
                  type="date"
                  placeholder=""
                  v-model="formItem.probationEndDate"
                  style="width: 100%"
                >
                </Date-picker>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="3" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="合同信息" />
        <Form
          :label-width="140"
          slot="content"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :model="formItem"
          ref="formItem"
          :rules="rules"
          :disabled="isHistory"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="合同开始日期：" prop="contractStartDate">
                <Date-picker
                  v-model="formItem.contractStartDate"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                  @on-change="contractChange"
                >
                </Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="合同结束日期：">
                <Date-picker
                  v-model="formItem.contractEndDate"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                  @on-change="dateChange"
                >
                </Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="合同年限">
                <Input v-model="formItem.laborContractPeriod" />
                <!-- <Row>
                        <Col span="5" ><Input /></Col>年
                        <Col span="5" offset="2"><Input /></Col>月
                        <Col span="5" offset="2"><Input /></Col>日    
                    </Row> -->
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="合同类型：">
                <Select
                  v-model="formItem.contractType"
                  :clearable="true"
                  placeholder=""
                  @on-change="contractChange"
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in contractTypeList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="4" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="工作服信息" />
        <Form
          :label-width="140"
          slot="content"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :disabled="isHistory"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="身高：">
                <Input v-model="formItem.height" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="体重：">
                <Input v-model="formItem.weight"></Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="衣服尺码：">
                <Input v-model="formItem.clothesSize" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="裤子尺码：">
                <Input v-model="formItem.trousersSize" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="鞋子尺码：">
                <Input v-model="formItem.shoesSize" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="" :label-width="0">
                <Button type="primary" @click="selectSize">尺码参照表</Button>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="5" hide-arrow style="margin-bottom: 20px; border: 0">
        <!-- 审批历史 -->
        <FormTitle :titleText="$t('审批历史')" />
        <Table
          border
          :columns="columns3"
          :data="data3"
          slot="content"
          style="margin:30px"
        >
        </Table>
      </Panel>
    </Collapse>
    <div class="btnRight">
      <Button class="applyBtnRight" v-if="!isHistory" @click="importCG">{{
        $t("导入草稿")
      }}</Button>
      <Button class="applyBtnRight" v-if="!isHistory" @click="saveCG">{{
        $t("保存草稿")
      }}</Button>
      <!-- <Button type="primary" class="applyBtnRight" v-if="!isHistory">保存</Button> -->
      <Button
        type="primary"
        class="applyBtnRight"
        v-if="!isHistory"
        @click="submit"
        >提交</Button
      >
      <Button type="primary" class="applyBtnRight" @click="returnApply"
        >返回</Button
      >
      <!-- <Button type="primary"  v-on:click="getPDF()">导出PDF</Button> -->
    </div>
    <!-- 选择员工 -->
    <Modal v-model="showOpenSeleEmp" title="选择员工" width="860px">
      <div>查询条件</div>
      <Form inline :label-width="50" label-position="left">
        <FormItem label="应聘职位" :label-width="85">
          <Input
            type="text"
            v-model="searchList.candidatePosition"
            placeholder="请输入应聘职位"
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem :label="$t('员工姓名')" :label-width="100">
          <Input
            type="text"
            v-model="searchList.userName"
            placeholder="请输入员工姓名"
            style="width: 150px"
          ></Input>
        </FormItem>
        <Button type="primary" @click="selectPerson"
          ><!-- 检索 -->{{ $t("Search") }}</Button
        >
      </Form>
      <Table
        ref="myTable"
        :columns="columns2"
        :data="data2"
        border
        :loading="loading1"
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="select1(row, index)"
            >选择</Button
          >
        </template>
      </Table>
      <div class="pageBox">
        <div></div>
        <Page :total="total" @on-change="pageChange" />
      </div>
      <div slot="footer">
        <!-- <Button type="text" @click="handleCancle">取消</Button>   -->
      </div>
    </Modal>
    <!-- 应聘申请表 -->
    <Modal v-model="JobApplicationForm" title="应聘申请表" width="1300px">
      <JobApplicationForm comHistory="1" ref="ApplicationForm" />
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="sizeModal" title="尺码参照表" width="900px">
      <Table
        ref="ref"
        :columns="columns4"
        :data="data4"
        border
        :loading="loading2"
        style="height: 520px;"
      ></Table>
      <span style="margin-bottom: 30px; color:blue;float:right"
        >以上尺码仅供参考</span
      >
      <Page
        style="margin-top: 10px;"
        :total="total2"
        @on-change="pageChange2"
      />

      <div slot="footer"></div>
    </Modal>
    <Spin size="large" fix v-if="loading"></Spin>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
  </div>
</template>

<script>
import axios from "axios";
import JobApplicationForm from "../MyManagement/JobApplicationForm";
import DateUtil from "../../../util/DateUtil";
export default {
  components: {
    JobApplicationForm
  },
  data() {
    return {
      rules: {
        candidatePosition: [{ required: true, message: "请填写应聘职位！" }],
        latestHiringDate: [{ required: true, message: "请填写雇佣日！" }],
        contractStartDate: [
          { required: true, message: "请填写合同开始日期！" }
        ],
        contractType: [
          {
            required: true,
            type: "date",
            trigger: "change",
            message: "请填写合同类型！"
          }
        ]
      },
      loading2: false,
      value2: [1, 2, 3, 4, 5],
      date: new DateUtil(),
      formItem: {
        age: "",
        applicantDate: "",
        applicationResource: "",
        applyOnboardingEducations: "",
        applyOnboardingSocials: "",
        applyOnboardingWorks: "",
        bankAccountNumber: "",
        bankBranch: "",
        bankName: "",
        beInitiateApplication: "",
        candidatePosition: "",
        clarifyOne: "",
        clarifyThree: "",
        clarifyTwo: "",
        clothesSize: "",
        contractEndDate: "",
        contractStartDate: "",
        contractType: "",
        firstNamePinyin: "",
        height: "",
        homeAddress: "",
        id: "",
        internalRecommenderInfo: "",
        laborContractPeriod: "",
        lastNamePinyin: "",
        latestHiringDate: "",
        legalAddress: "",
        mail: "",
        maritalStatus: "",
        mobilePersonal: "",
        nationalIdNumber: "",
        optionName: "",
        passportnumber: "",
        probationEndDate: "",
        resignationNoticePeriod: "",
        resultList: "",
        serviceStartDate: "",
        shoesSize: "",
        signatureApplicant: "",
        socialWorkStartDate: "",
        trousersSize: "",
        userEname: "",
        userName: "",
        weight: ""
      },
      searchList: {},
      showOpenSeleEmp: false,
      JobApplicationForm: false,
      contractTypeList: [],
      nationList: [],
      genderList: [],
      nationalityList: [],
      columns2: [
        {
          title: "申请单状态",
          key: "beInitiateApplication",
          align: "center"
        },
        {
          title: "申请日",
          key: "applicantDate",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.applicantDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "应聘职位",
          key: "candidatePosition",
          align: "center"
        },
        {
          title: "中文姓名",
          key: "userName",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          width: 100,
          align: "center"
        }
      ],
      data2: [],
      columns4: [
        {
          title: "性别",
          key: "gender",
          align: "center"
        },
        {
          title: "部位",
          key: "type",
          align: "center"
        },
        {
          title: "身高",
          key: "height",
          align: "center"
        },
        {
          title: "体重",
          key: "weight",
          align: "center"
        },
        {
          title: "建议尺码",
          key: "size",
          align: "center"
        }
      ],
      data4: [],
      sizeModal: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      pageInfo2: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      total2: 0,
      loading: false,
      loading1: false,
      isHistory: false,
      columns3: [
        {
          title: this.$t("审批流名称"),
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("实际审批者"),
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("审批时间"),
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: this.$t("审批状态"),
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: this.$t("审批意见"),
          key: "message",
          align: "center",
          width: "435"
        }
      ],
      data3: []
    };
  },
  watch: {
    "formItem.latestHiringDate"(val) {
      if (val) {
        let y,
          m,
          d,
          newDate,
          oldDate = new Date(val);

        oldDate.setDate(oldDate.getDate() + 180);
        var y = oldDate.getFullYear();
        var m = oldDate.getMonth() + 1;
        var d = oldDate.getDate();
        newDate = new Date(y + "-" + m + "-" + d);
        this.$set(this.formItem, "probationEndDate", newDate);

        // 有效雇佣日
        this.formItem.serviceStartDate = val;
        // 合同开始日期
        this.formItem.contractStartDate = val;
      }
    },
    "formItem.contractEndDate"(val) {
      if (val && this.formItem.contractStartDate) {
        setTimeout(() => {
          var d =
            Math.abs(
              this.formItem.contractStartDate.getTime() -
                new Date(val).getTime()
            ) /
            1000 /
            24 /
            60 /
            60;
          var year = Math.floor(d / 365);
          this.$set(this.formItem, "laborContractPeriod", year);
        }, 500);
      }
    },
    "formItem.contractType"(val) {
      if (val == "Unlimit") {
        this.$set(this.formItem, "laborContractPeriod", "");
      }
    }
  },
  created() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
      let obj = { instanceId: this.getQueryVariable("instanceId") };
      axios.post("ApplyOnboarding/selectApplyOnboarding", obj).then(res => {
        if (res) {
          this.formItem = res.onboarding;
          this.data3 = res.logMap;
        }
      });
    }
    if (this.getQueryVariable("id")) {
      this.getData();
    }
    this.getSelectLabel();
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  methods: {
    selectSize() {
      this.sizeModal = true;
      this.selectSizeInfo();
    },
    selectSizeInfo() {
      this.loading2 = true;
      let obj = {
        pageNo: this.pageInfo2.pageNo,
        pageSize: this.pageInfo2.pageSize
      };
      axios.post("/Reference/selectSize", obj).then(res => {
        if (res) {
          this.data4 = res.data;
          this.total2 = parseInt(res.pageInfo.total);
        }
        this.loading2 = false;
      });
    },
    //打开草稿列表
    importCG() {
      this.$refs.cgTem.getInternation();
      //草稿type 操作人
      this.$refs.cgTem.popShow(
        "OB01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      );
    },
    getData() {
      let obj = {
        id: this.getQueryVariable("id")
      };
      this.loading = true;
      axios
        .post(
          "OnboardingApplication/SelectIndividualOnboardingApplication",
          obj
        )
        .then(res => {
          this.loading = false;
          if (res) {
            this.formItem = res.data[0];
          }
        });
    },
    //保存草稿
    saveCG() {
      this.$refs.cgPop.getInternation();
      this.formItem.beInitiateApplication =
        this.formItem.beInitiateApplication == "已发起" ? "1" : "0";
      this.formItem.latestHiringDate =
        this.formItem.latestHiringDate == ""
          ? null
          : this.date.dateVal(this.formItem.latestHiringDate, "YYYY-MM-DD");
      this.formItem.serviceStartDate =
        this.formItem.serviceStartDate == ""
          ? null
          : this.date.dateVal(this.formItem.serviceStartDate, "YYYY-MM-DD");
      this.formItem.socialWorkStartDate =
        this.formItem.socialWorkStartDate == ""
          ? null
          : this.date.dateVal(this.formItem.socialWorkStartDate, "YYYY-MM-DD");
      this.formItem.probationEndDate =
        this.formItem.probationEndDate == ""
          ? null
          : this.date.dateVal(this.formItem.probationEndDate, "YYYY-MM-DD");
      this.formItem.contractStartDate =
        this.formItem.contractStartDate == ""
          ? null
          : this.date.dateVal(this.formItem.contractStartDate, "YYYY-MM-DD");
      this.formItem.contractEndDate =
        this.formItem.contractEndDate == ""
          ? null
          : this.date.dateVal(this.formItem.contractEndDate, "YYYY-MM-DD");
      //草稿type 草稿内容
      this.$refs.cgPop.popShow("OB01", { formItem: this.formItem });
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      var obj = JSON.parse(row.draftContent);
      this.formItem = obj.formItem;
    },
    getSelectLabel() {
      axios
        .post("ApplyOnboarding/selectApplyOnboardingComboBox", {})
        .then(res => {
          if (res) {
            this.contractTypeList = res.CONTRACTTYPE;
            this.nationList = res.ETHNIC;
            this.genderList = res.GENDER;
            this.nationalityList = res.PPISSUECOUNTRY;
          }
        });
    },
    openSelectEmp() {
      this.showOpenSeleEmp = true;
    },
    selectPerson() {
      let obj = {
        userName: this.searchList.userName,
        candidatePosition: this.searchList.candidatePosition,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.loading1 = true;
      axios
        .post(
          "OnboardingApplication/SelectIndividualOnboardingApplication",
          obj
        )
        .then(res => {
          this.loading1 = false;
          if (res) {
            this.data2 = res.data;
            this.total = Number(res.pageInfo.total);
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.selectPerson();
    },
    pageChange2(val) {
      this.pageInfo2.pageNo = val;
      this.selectSizeInfo();
    },
    select1(row, index) {
      this.formItem = row;
      this.showOpenSeleEmp = false;
    },
    openJobApplaction() {
      this.JobApplicationForm = true;
      this.$refs.ApplicationForm.formItem = this.formItem;
      this.$refs.ApplicationForm.data1 = this.formItem.applyOnboardingEducations;
      this.$refs.ApplicationForm.data2 = this.formItem.applyOnboardingWorks;
      this.$refs.ApplicationForm.data3 = this.formItem.applyOnboardingSocials;
      this.$refs.ApplicationForm.showBtn = false;
      this.$refs.ApplicationForm.disabledVal = true;
    },
    contractChange() {
      if (this.formItem.contractStartDate && this.formItem.contractType) {
        switch (this.formItem.contractType) {
          case "OneYear":
            this.$set(
              this.formItem,
              "contractEndDate",
              this.getNumberYear(this.formItem.contractStartDate, 1)
            );
            break;
          case "TwoYear":
            this.$set(
              this.formItem,
              "contractEndDate",
              this.getNumberYear(this.formItem.contractStartDate, 2)
            );
            break;
          case "ThreeYear":
            this.$set(
              this.formItem,
              "contractEndDate",
              this.getNumberYear(this.formItem.contractStartDate, 3)
            );
            break;
          default:
            this.formItem.contractEndDate = "";
        }
      }
    },
    //获取指定日期的n年后
    getNumberYear(date, n) {
      var dd = new Date(date);
      var y = dd.getFullYear() + Number(n);
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    dateChange() {
      if (this.formItem.contractStartDate && this.formItem.contractEndDate) {
        var d =
          Math.abs(
            this.formItem.contractStartDate.getTime() -
              this.formItem.contractEndDate.getTime()
          ) /
          1000 /
          24 /
          60 /
          60;
        var year = Math.floor(d / 365);
        this.$set(this.formItem, "laborContractPeriod", year);
      }
    },
    returnApply() {
      if (this.isHistory) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.go(-1);
      }
    },
    submit() {
      if (this.formItem.id == undefined) {
        this.$Message.error("请选择入职员工！");
        return;
      }
      if (this.formItem.latestHiringDate == "") {
        this.$Message.error("请填写必填项");
        return;
      }
      this.$refs["formItem"].validate(valid => {
        if (!valid) {
          this.$Message.error("请填写必填项");
          return;
        } else {
          this.$Modal.confirm({
            title: this.$notice("submission"),
            content: "",
            onOk: () => {
              this.handle();
            },
            onCancel: () => {}
          });
        }
        console.log(this.formItem);
      });
    },
    handle() {
      this.loading = true;
      this.formItem.beInitiateApplication = "1";
      this.formItem.latestHiringDate =
        this.formItem.latestHiringDate == ""
          ? null
          : this.date.dateVal(this.formItem.latestHiringDate, "YYYY-MM-DD");
      this.formItem.serviceStartDate =
        this.formItem.serviceStartDate == ""
          ? null
          : this.date.dateVal(this.formItem.serviceStartDate, "YYYY-MM-DD");
      this.formItem.socialWorkStartDate =
        this.formItem.socialWorkStartDate == ""
          ? null
          : this.date.dateVal(this.formItem.socialWorkStartDate, "YYYY-MM-DD");
      this.formItem.probationEndDate =
        this.formItem.probationEndDate == ""
          ? null
          : this.date.dateVal(this.formItem.probationEndDate, "YYYY-MM-DD");
      this.formItem.contractStartDate =
        this.formItem.contractStartDate == ""
          ? null
          : this.date.dateVal(this.formItem.contractStartDate, "YYYY-MM-DD");
      this.formItem.contractEndDate =
        this.formItem.contractEndDate == ""
          ? null
          : this.date.dateVal(this.formItem.contractEndDate, "YYYY-MM-DD");

      let arr = [
        {
          stringData1: "OB01",
          type: "B31",
          objData1: {
            apply_name: this.formItem.userName,
            apply_position: this.formItem.candidatePosition,
            status: this.formItem.beInitiateApplication,
            be_agent: 0,
            agent_apply_user_id: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).userId,
            agent_apply_serialnumber: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).serialnumber,
            agent_apply_name: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).userName,
            application_id: this.formItem.id
          }
        }
      ];
      axios.post("/process/execute", arr).then(res1 => {
        if (res1) {
          let obj = { ...this.formItem };
          axios
            .post("OnboardingApplication/UpdateOnboardingApplication", obj)
            .then(res => {
              this.loading = false;
              if (res) {
                this.$Message.info(this.$t("sbumit_Success"));
                this.$router.push(
                  "/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27"
                );
              }
            });
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style scoped>
.ivu-collapse-content {
  color: #515a6e;
  padding: 0px !important;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/OnboardingApply.vue